import { createPaginatedSlice } from "../../helpers/reduxHelper";

const searchMembers = createPaginatedSlice('searchMembers');

export const searchMembersActions = searchMembers.actions
export const searchMembersSelector = state => state.searchMembers;
export const searchMembersReducer = searchMembers.reducer;
export default searchMembersReducer

export const searchMembersSelectors = searchMembers.LF.selectors